import { datadogLogs } from "@datadog/browser-logs";

import { createStorefrontRequest } from "@repo/shopifyV2/graphql/createStorefrontRequest";

import { DOMAIN, PREVIEW_DOMAIN, SHOPIFY_DOMAIN } from "@const/urls";

const KEYS = {
  ko: {
    uri: SHOPIFY_DOMAIN.ko,
    token: import.meta.env.VITE_KR_STOREFRONT_ACCESS_TOKEN,
  },
  en: {
    uri: SHOPIFY_DOMAIN.en,
    token: import.meta.env.VITE_INTL_STOREFRONT_ACCESS_TOKEN,
  },
  jp: {
    uri: SHOPIFY_DOMAIN.jp,
    token: import.meta.env.VITE_JP_STOREFRONT_ACCESS_TOKEN,
  },
};

const lang = localStorage.getItem("i18nextLng");
let newLang = "ko";

if (window.location.href.includes("localhost") || window.location.hostname.includes("ngrok")) {
  newLang = lang ? lang : newLang;
} else {
  if (window.location.href.includes(DOMAIN.ko) || window.location.href.includes(PREVIEW_DOMAIN.ko)) {
    newLang = "ko";
  }

  if (window.location.href.includes(DOMAIN.en) || window.location.href.includes(PREVIEW_DOMAIN.en)) {
    newLang = "en";
  }

  if (window.location.href.includes(DOMAIN.jp) || window.location.href.includes(PREVIEW_DOMAIN.jp)) {
    newLang = "jp";
  }
}

export const storefrontRequest = createStorefrontRequest({
  resolveEndpoint: () => KEYS[newLang as keyof typeof KEYS],
  onGraphQLErrors: (errors) => {
    errors.forEach(({ message, locations, path }) => {
      datadogLogs.logger.error("[GRAPHQL] GraphQL error", {
        message,
        location: JSON.stringify(locations),
        path: JSON.stringify(path),
      });
    });
  },
  onNetworkError: (error) => {
    datadogLogs.logger.error("[GRAPHQL] Network error", { networkError: error });
  },
});
